import { render } from "./speed_icon.vue?vue&type=template&id=091cc380"
import script from "./speed_icon.vue?vue&type=script&lang=js"
export * from "./speed_icon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__